// src/components/Chat/money.ts

/**
 * Сумма в рублях → «10 000,00 ₽».
 *
 * Абонементы, их продажи и списания ведутся в рублях: так их заводит консоль
 * и так они лежат в базе. Делить на 100 при показе нельзя, иначе абонемент
 * за 10 000 ₽ превращается в «100,00 ₽».
 *
 * Неизвестную валюту печатаем кодом, а не выдуманным символом.
 */
export const formatRubles = (amountInRubles: number, currency?: string | null): string => {
    const amount = Number.isFinite(amountInRubles) ? amountInRubles : 0;
    const code = currency && currency.trim() !== '' ? currency.trim() : 'RUB';

    try {
        return amount.toLocaleString('ru-RU', {
            style: 'currency',
            currency: code,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    } catch {
        // Intl падает на экзотическом коде валюты — показываем число и код.
        return `${amount.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${code}`;
    }
};
